import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form, Card } from 'semantic-ui-react';
import { API, showError, showSuccess } from '../../helpers';

const AddUser = () => {
  const { t } = useTranslation();
  const originInputs = {
    username: '',
    display_name: '',
    password: '',
    email: '',
    mobile: '',
    company: '',
    department: '',
    source: '',
    sales_owner: '',
    customer_level: '',
    remark: '',
  };
  const [inputs, setInputs] = useState(originInputs);
  const {
    username,
    display_name,
    password,
    email,
    mobile,
    company,
    department,
    source,
    sales_owner,
    customer_level,
    remark,
  } = inputs;

  const handleInputChange = (e, { name, value }) => {
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const submit = async () => {
    if (inputs.username === '' || inputs.password === '') return;
    const res = await API.post(`/api/user/`, inputs);
    const { success, message } = res.data;
    if (success) {
      showSuccess(t('user.messages.create_success'));
      setInputs(originInputs);
    } else {
      showError(message);
    }
  };

  return (
    <div className='dashboard-container'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <Card.Header className='header'>{t('user.add.title')}</Card.Header>
          <Form autoComplete='off'>
            <Form.Field>
              <Form.Input
                label={t('user.edit.username')}
                name='username'
                placeholder={t('user.edit.username_placeholder')}
                onChange={handleInputChange}
                value={username}
                autoComplete='off'
                required
              />
            </Form.Field>
            <Form.Field>
              <Form.Input
                label={t('user.edit.display_name')}
                name='display_name'
                placeholder={t('user.edit.display_name_placeholder')}
                onChange={handleInputChange}
                value={display_name}
                autoComplete='off'
              />
            </Form.Field>
            <Form.Field>
              <Form.Input
                label={t('user.edit.password')}
                name='password'
                type='password'
                placeholder={t('user.edit.password_placeholder')}
                onChange={handleInputChange}
                value={password}
                autoComplete='off'
                required
              />
            </Form.Field>
            <Form.Field>
              <Form.Input
                label='Email'
                name='email'
                placeholder='Email'
                onChange={handleInputChange}
                value={email}
                autoComplete='off'
              />
            </Form.Field>
            <Form.Group widths='equal'>
              <Form.Input
                label='Mobile'
                name='mobile'
                placeholder='Mobile'
                onChange={handleInputChange}
                value={mobile}
                autoComplete='off'
              />
              <Form.Input
                label='Company'
                name='company'
                placeholder='Company'
                onChange={handleInputChange}
                value={company}
                autoComplete='off'
              />
            </Form.Group>
            <Form.Group widths='equal'>
              <Form.Input
                label='Department'
                name='department'
                placeholder='Department'
                onChange={handleInputChange}
                value={department}
                autoComplete='off'
              />
              <Form.Input
                label='Source'
                name='source'
                placeholder='Source'
                onChange={handleInputChange}
                value={source}
                autoComplete='off'
              />
            </Form.Group>
            <Form.Group widths='equal'>
              <Form.Input
                label='Sales Owner'
                name='sales_owner'
                placeholder='Sales Owner'
                onChange={handleInputChange}
                value={sales_owner}
                autoComplete='off'
              />
              <Form.Input
                label='Customer Level'
                name='customer_level'
                placeholder='Customer Level'
                onChange={handleInputChange}
                value={customer_level}
                autoComplete='off'
              />
            </Form.Group>
            <Form.Field>
              <Form.TextArea
                label='Remark'
                name='remark'
                placeholder='Remark'
                onChange={handleInputChange}
                value={remark}
              />
            </Form.Field>
            <Button positive type='submit' onClick={submit}>
              {t('user.edit.buttons.submit')}
            </Button>
          </Form>
        </Card.Content>
      </Card>
    </div>
  );
};

export default AddUser;
